import AppLayout from './layouts/AppLayout.vue';
import AuthLayout from './layouts/AuthLayout.vue';
import ChildLayout from './layouts/ChildLayout.vue';
import StudiesLayout from './layouts/StudiesLayout.vue';
import ForceClubActivateModule from './modules/ForceClubActivateModule.vue';
import ForceClubActivateSuccessModule from './modules/ForceClubActivateSuccessModule.vue';
import CheckEmailModule from './modules/auth/CheckEmailModule.vue';

/* 新規会員登録【AUBE】 */
import AuthLayoutAube from './layouts/AuthLayoutAube.vue';
import CreateUserModuleAube from './modules/auth/aube/CreateUserModule.vue';
import RegistrationAubeModule from './modules/auth/aube/RegistrationModule.vue';
import RegistrationAubeConfirmModule from './modules/auth/aube/RegistrationConfirmModule.vue';
import RegistrationAubeCompleteModule from './modules/auth/aube/RegistrationCompleteModule.vue';
import CheckEmailModuleAube from './modules/auth/aube/CheckEmailModule.vue';
import RegistrationAubeErrorModule from './modules/auth/aube/RegistrationErrorModule.vue';

/* 新規会員登録【ForceClub】 */
import AuthLayoutForceclub from './layouts/AuthLayoutForceclub.vue';
import CreateUserModule from './modules/auth/forceclub/CreateUserModule.vue';
import RegistrationModule from './modules/auth/forceclub/RegistrationModule.vue';
import RegistrationConfirmModule from './modules/auth/forceclub/RegistrationConfirmModule.vue';
import RegistrationCompleteModule from './modules/auth/forceclub/RegistrationCompleteModule.vue';
import CheckEmailModuleForceclub from './modules/auth/forceclub/CheckEmailModule.vue';
import RegistrationErrorModule from './modules/auth/forceclub/RegistrationErrorModule.vue';

import LoginModule from './modules/auth/LoginModule.vue';
import Google2saLoginModule from './modules/auth/Google2saLoginModule.vue';
import LogoutModule from './modules/auth/LogoutModule.vue';
import KYCSettings from './modules/kyc-settings/KYCSettings.vue';
import KYCSettingsComplete from './modules/kyc-settings/KYCSettingsComplete.vue';
import Messages from './modules/Messages.vue';
import Settings from './modules/Settings.vue';
import UserChildAccount from './modules/user/UserChildAccount.vue';
import PageNotFoundModule from './modules/PageNotFoundModule.vue';
import ResetPassword from './modules/user/ResetPassword.vue';
import ResetPasswordComplete from './modules/user/ResetPasswordComplete.vue';

import Company from './modules/guest/Company.vue';
import BonusTerms from './modules/guest/BonusTerms.vue';
import Outline from './modules/guest/Outline.vue';
import Policy from './modules/guest/Policy.vue';
import Tokushoho from './modules/guest/Tokushoho.vue';
import LandingPage from './modules/LandingPage/LandingPage.vue';

//新規登録【アドバンス会員】【ベーシック会員】ヘッダー・フッター
import LayoutForce from './layouts/LayoutForce.vue';
import LayoutAube from './layouts/LayoutAube.vue';
import OutlineForce from './modules/guest/OutlineForce.vue';
import OutlineAube from './modules/guest/OutlineAube.vue';
import commonFAQ from "./modules/guest/commonFAQ";
import commonPolicy from './modules/guest/commonPolicy.vue';
import commonCompany from './modules/guest/commonCompany.vue';

import Home from './modules/guest/Home.vue';
import EditUserProfile from "./modules/user/EditUserProfile";
import EditUserProfileConfirm from "./modules/user/EditUserProfileConfirm";
import EditUserProfileComplete from "./modules/user/EditUserProfileComplete";
import DeactivateAdvanceUser from "./modules/user/deactivate/DeactivateAdvanceUser";
import DeactivatingCompleteAdvanceUser from "./modules/user/deactivate/DeactivatingCompleteAdvanceUser.vue";
import DeactivateBasicUser from "./modules/user/deactivate/DeactivateBasicUser";
import DeactivatingCompleteBasicUser from "./modules/user/deactivate/DeactivatingCompleteBasicUser";
import TopPage from './modules/TopPage.vue';
import TokenHistory from "./modules/token/TokenHistory";
import TokenWithdrawalConfirm from "./modules/token/TokenWithdrawalConfirm";
import TokenWithdrawalConfirmEmailSent from "./modules/token/TokenWithdrawalConfirmEmailSent";
import TokenWithdrawalConfirmFromEmail from "./modules/token/TokenWithdrawalConfirmFromEmail";
import ForgotPasswordModule from "./modules/auth/ForgotPasswordModule";
import ChangePasswordModule from "./modules/auth/ChangePasswordModule";
import ChangePasswordCompleteModule from "./modules/auth/ChangePasswordCompleteModule.vue";
import AuthErrorModule from "./modules/auth/AuthErrorModule.vue";
import ChangeEmailModule from "./modules/user/ChangeEmailModule";
import ChangeEmailConfirmModule from "./modules/user/ChangeEmailConfirmModule";
import ChangeEmailRequestModule from "./modules/user/ChangeEmailRequestModule";
import ChangeEmailRequestConfirmModule from "./modules/user/ChangeEmailRequestConfirmModule";
import ChangeEmailCompleteModule from "./modules/auth/ChangeEmailCompleteModule";
import ChangeEmailErrorModule from "./modules/user/ChangeEmailErrorModule";
import Google2saSettings from "./modules/auth/Google2saSettings";

import FAQ from "./modules/guest/FAQ";

//初回フォルシング契約
import MembershipFeePolicy   from "./modules/MembershipFee/MembershipFeePolicy";       //フォルシング開始手続き画面(規約)
import MembershipFeePayments from "./modules/MembershipFee/MembershipFeePayments";     //フォルシング開始手続き画面(申込)
import MembershipFeeComplete from "./modules/MembershipFee/MembershipFeeComplete";     //フォルシング開始手続き画面(完了)
//次回フォルシング契約
import MembershipFeePolicyRenewal    from "./modules/MembershipFee/MembershipFeePolicyRenewal";    //フォルシング開始(更新)手続き画面(規約)
import MembershipFeeConditionRenewal from "./modules/MembershipFee/MembershipFeeConditionRenewal"; //フォルシング開始手続き画面
import MembershipFeePaymentsRenewal  from "./modules/MembershipFee/MembershipFeePaymentsRenewal";  //フォルシング開始(更新)手続き画面(申込)
import MembershipFeeCompleteRenewal  from "./modules/MembershipFee/MembershipFeeCompleteRenewal";  //フォルシング開始(更新)手続き画面(完了)

import OrderAddress from "./modules/order/OrderAddress";
import OrderAmount from "./modules/order/OrderAmount";
import OrderConfirm from "./modules/order/OrderConfirm";
import OrderPayment from "./modules/order/OrderPayment";
import OrderSuccess from "./modules/order/OrderSuccess";
import OrderFailure from "./modules/order/OrderFailure";

import ForthingDetail from './modules/forthing/ForthingDetail';
import HistoryOfForthingAgreement from './modules/forthing/HistoryOfForthingAgreement';
import ForthingHistory from './modules/forthing/ForthingHistory';
import TokenDetail from "./modules/token/TokenDetail";
import TokenConfirm from "./modules/token/TokenConfirm";
import TokenCSV from "./modules/token/TokenCsv";
import StudiesTop from "./modules/studies/Top";
import StudiesDetail from "./modules/studies/Detail";
import StudiesCategory from "./modules/studies/Category";
import StudiesError from "./modules/studies/Error";

import ExBonusHistory from "./modules/exbonus/ExBonusHistory";

import Contact from './modules/contact/Top.vue';
import ContactConfirm from './modules/contact/Confirm.vue';
import ContactComplate from './modules/contact/Complate.vue';

import AUBEGuideModule from './modules/guide/AUBEGuideModule.vue';

import News from './modules/news/News.vue';
import { FORTHING_MEMBER_CHILD, FORTHING_MEMBER_PARENT, GENERAL_FREE_MEMBER_CHILD, GENERAL_FREE_MEMBER_PARENT, FORTHING_MEMBER_SUPPORT_CHILD, FORTHING_MEMBER_SUPPORT_PARENT} from './utils/AuthUtil';

/* HEC Saving */
import AutomaticRemittance from './modules/HECSaving/AutomaticRemittance.vue';
import AutomaticRemittanceConfirm from './modules/HECSaving/AutomaticRemittanceConfirm.vue';
import AutomaticRemittanceComplete from './modules/HECSaving/AutomaticRemittanceComplete.vue';
import HeacSavingApplication from './modules/HECSaving/HecSavingApplication.vue';

export default [
    {
        path: '/auth',
        component: AuthLayout,
        children: [
            {
                path: '/login',
                component: LoginModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.login',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/login/2sa',
                component: Google2saLoginModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.2saLogin',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/logout',
                component: LogoutModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.logout',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/forgot-password',
                component: ForgotPasswordModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.forgotPassword',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/forgot-password/sent',
                component: CheckEmailModule,
                meta: {
                    requiresAuth: false,
                    translateKey: "forgotPasswordEmail",
                    titleKey: 'title.forgotPassword',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/forgot-password/update',
                component: ChangePasswordModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.forgotPassword',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/forgot-password/complete',
                component: ChangePasswordCompleteModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.forgotPassword',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/forgot-password/error',
                component: AuthErrorModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.forgotPassword',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/change-mail',
                component: ChangeEmailModule,
                name: 'changeMail',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.changeMail',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/change-mail-confirm',
                component: ChangeEmailConfirmModule,
                name: 'changeMailConfirm',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.changeMail',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/change-mail-error',
                component: ChangeEmailErrorModule,
                name: 'changeMailError',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.changeMail',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: '/change-mail-complete',
                component: ChangeEmailCompleteModule,
                name: 'changeMailComplete',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.changeMail',
                    authorizedMembershipTypes: undefined,
                }
            },
        ]
    },
    //【forceclub】新規登録
    {
        path: '/auth',
        component: AuthLayoutForceclub,
        children: [
            {
                //新規登録画面
                path: '/registration',
                component: CreateUserModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //メール送信完了画面
                path: '/registration-forceclub/check-email',
                component: CheckEmailModuleForceclub,
                meta: {
                    requiresAuth: false,
                    translateKey: "checkEmail",
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //プロフィール入力画面
                path: '/registration-forceclub/continue',
                component: RegistrationModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //プロフィール確認画面
                path: '/registration-forceclub/confirm',
                component: RegistrationConfirmModule,
                meta: {
                    requiresAuth: false,
                    //translateKey: "checkEmail",
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //プロフィール完了画面
                path: '/registration-forceclub/complete',
                component: RegistrationCompleteModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //新規登録エラー画面
                path: '/registration-forceclub/error',
                component: RegistrationErrorModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
        ]
    },
    //【AUBE】新規登録
    {
        path: '/auth',
        component: AuthLayoutAube,
        children: [
            {
                //新規登録画面
                path: '/registration-new',
                component: CreateUserModuleAube,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //メール送信完了画面
                path: '/registration/check-email',
                component: CheckEmailModuleAube,
                meta: {
                    requiresAuth: false,
                    translateKey: "checkEmail",
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //プロフィール入力画面
                path: '/registration/continue',
                component: RegistrationAubeModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //プロフィール確認画面
                path: '/registration/confirm',
                component: RegistrationAubeConfirmModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //プロフィール完了画面
                path: '/registration/complete',
                component: RegistrationAubeCompleteModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                //新規登録エラー画面
                path: '/registration/error',
                component: RegistrationAubeErrorModule,
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.registration',
                    authorizedMembershipTypes: undefined,
                }
            },
        ]
    },
    
    {
        path: '/child',
        component: ChildLayout,
        children: [
            {
                path: 'change-password',
                component: ResetPassword,
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.resetPassword',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: 'reset-password-complete',
                component: ResetPasswordComplete,
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.resetPassword',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
        ]
    },
    {
        path: '/account',
        component: AppLayout,
        children: [
            {
                path: 'sub-account',
                component: UserChildAccount,
                name: 'subAccount',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'title.subAccount',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'edit-profile',
                component: EditUserProfile,
                name: 'editUserProfile',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'title.editProfile',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'deactivate-advance',
                component: DeactivateAdvanceUser,
                name: 'deactivateAdvance',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'deactivate-advance/complete',
                component: DeactivatingCompleteAdvanceUser,
                name: 'deactivateAdvanceComplete',
                meta: {
                    requiresAuth: false,
                    parent: 'settings',
                    authorizedMembershipTypes: undefined
                }
            },
            {
                path: 'deactivate-basic',
                component: DeactivateBasicUser,
                name: 'deactivateBasic',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    authorizedMembershipTypes: [
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'deactivate-basic/complete',
                component: DeactivatingCompleteBasicUser,
                name: 'deactivateBasicComplete',
                meta: {
                    requiresAuth: false,
                    parent: 'settings',
                    authorizedMembershipTypes: undefined
                }
            },
            {
                path: 'edit-profile-confirm',
                component: EditUserProfileConfirm,
                name: 'editUserProfileConfirm',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'title.editProfile',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'edit-profile-complete',
                component: EditUserProfileComplete,
                name: 'editUserProfileComplete',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'title.editProfile',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'change-mail-request',
                component: ChangeEmailRequestModule,
                name: 'changeMailRequest',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'title.changeMail',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'change-mail-request-confirm',
                component: ChangeEmailRequestConfirmModule,
                name: 'changeMailRequestConfirm',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'title.changeMail',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'change-mail-confirm',
                component: ChangeEmailConfirmModule,
                name: 'changeMailConfirm',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'title.changeMail',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'change-mail-error',
                component: ChangeEmailErrorModule,
                name: 'changeMailError',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'title.changeMail',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'reset-password',
                component: ResetPassword,
                name: 'resetPassword',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'title.resetPassword',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'reset-password-complete',
                component: ResetPasswordComplete,
                name: 'resetPasswordComplete',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'menu.resetPasswordComplete',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: '2sa',
                component: Google2saSettings,
                name : 'google2sa-settings',
                meta: {
                    requiresAuth: true,
                    parent: 'settings',
                    titleKey: 'menu.google2sa-settings',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
        ]
    },
    {
        path: '/forthing',
        component: AppLayout,
        children: [
            {
                path: 'detail',
                component: ForthingDetail,
                name: 'forthing-detail',
                meta: {
                    requiresAuth: true,
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'history',
                component: ForthingHistory,
                name: 'forthing-history',
                meta: {
                    requiresAuth: true,
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'agreement-history',
                component: HistoryOfForthingAgreement,
                name: 'historyOfForthingAgreement',
                meta: {
                    titleKey: 'title.historyOfForthingAgreement',
                    requiresAuth: true,
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
        ]
    },
    {
        path: '/exbonus',
        component: AppLayout,
        children: [
            {
                path: 'history',
                component: ExBonusHistory,
                name: 'exbonus-history',
                meta: {
                    titleKey: 'title.exbonusHistory',
                    parent: 'settings',
                    requiresAuth: true,
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
        ]
    },
    {
        path: '/token',
        component: AppLayout,
        children: [
            {
                path: 'detail',
                component: TokenDetail,
                name: 'token-detail',
                meta: {
                    requiresAuth: true,
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'history',
                component: TokenHistory,
                name: 'token-history',
                meta: {
                    requiresAuth: true,
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'withdrawal/confirm',
                component: TokenWithdrawalConfirm,
                name: 'withdrawalTokenConfirm',
                meta: {
                    requiresAuth: true,
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: 'withdrawal/confirm/emailSent',
                component: TokenWithdrawalConfirmEmailSent,
                name: 'withdrawalTokenConfirmEmailSent',
                meta: {
                    requiresAuth: true,
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: 'withdrawal/confirm/email',
                component: TokenWithdrawalConfirmFromEmail,
                name: 'tokenWithdrawalConfirmFromEmail',
                meta: {
                    requiresAuth: true,
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: 'confirm',
                component: TokenConfirm,
                name: 'tokenConfirm',
                meta: {
                    requiresAuth: true,
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: 'csv',
                component: TokenCSV,
                name: 'tokenCsv',
                meta: {
                    parent: 'settings',
                    titleKey: 'menu.tokenCsv',
                    requiresAuth: true,
                    authorizedMembershipTypes: undefined,
                }
            },
        ]
    },
    {
        path: '/',
        component: AppLayout,
        children: [
            {
                path: '',
                component: Home,
                name: 'home',
                meta: {
                    requiresAuth: false,
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: 'guide',
                component: AUBEGuideModule,
                name: 'guide',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.guide',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: 'settings',
                component: Settings,
                name: 'settings',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.settings',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'activation',
                component: ForceClubActivateModule,
                name: 'activation',
                meta: {
                    requiresAuth: true,
                    parent: 'messages',
                    titleKey: 'title.activation',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'activation/success',
                component: ForceClubActivateSuccessModule,
                name: 'forceTabActivateSuccess',
                meta: {
                    requiresAuth: true,
                    parent: 'messages',
                    titleKey: 'title.activation',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'kyc-settings',
                component: KYCSettings,
                name: 'kycSettings',
                meta: {
                    requiresAuth: true,
                    parent: 'messages',
                    titleKey: 'title.kycSettings',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'kyc-settings-complete',
                component: KYCSettingsComplete,
                name: 'KYCSettingsComplete',
                meta: {
                    requiresAuth: true,
                    parent: 'messages',
                    titleKey: 'title.kycSettings',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'messages',
                component: Messages,
                name: 'messages',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.messages',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'hec-saving-application',
                component: HeacSavingApplication,
                name: 'hecSavingApplication',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.hecSavingApplication',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'hec-saving/automatic-remittance',
                component: AutomaticRemittance,
                name: 'automaticRemittance',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.hecSaving',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'hec-saving/automatic-remittance-confirm',
                component: AutomaticRemittanceConfirm,
                name: 'automaticRemittanceConfirm',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.hecSaving',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'hec-saving/automatic-remittance-complete',
                component: AutomaticRemittanceComplete,
                name: 'automaticRemittanceComplete',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.hecSaving',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'policy',
                component: Policy,
                name: 'policy',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.policy',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: 'tokushoho',
                component: Tokushoho,
                name: 'tokushoho',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.tokushoho',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'terms',
                component: Outline,
                name: 'terms',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.terms',
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: 'bonus/terms',
                component: BonusTerms,
                name: 'bonusTerms',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.bonusTerms',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            {
                path: 'company',
                component: Company,
                name: 'operating',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.company',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: 'top',
                component: TopPage,
                name: 'top',
                meta: {
                    requiresAuth: true,
                    authorizedMembershipTypes: undefined,
                }
            },
            {
                path: 'faq',
                component: FAQ,
                name: 'faq',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.faq',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: 'news',
                component: News,
                name: 'news',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.news',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: 'atemcard-landingpage',
                component: LandingPage,
                name: 'atemcard-landingpage',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.atemcard-landingpage',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
        ]
    },
    {
        path: '/studies',
        component: StudiesLayout,
        children: [
            {
                path: '/studies-top',
                component: StudiesTop,
                name: 'video',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.studiesTop',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: '/studies-detail',
                component: StudiesDetail,
                name: 'video-detail',
                meta: {
                    requiresAuth: false,
                    titleKey: 'studies.title.',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: '/studies-category',
                name: 'video-category',
                component: StudiesCategory,
                meta: {
                    requiresAuth: false,
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
            {
                path: '/studies-error',
                name: 'video-error',
                component: StudiesError,
                meta: {
                    requiresAuth: false,
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_CHILD,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        FORTHING_MEMBER_SUPPORT_CHILD,
                        GENERAL_FREE_MEMBER_PARENT,
                        GENERAL_FREE_MEMBER_CHILD,
                    ],
                }
            },
        ]
    },
    {
        path: '/contact-base',
        component: AppLayout,
        children: [
            {
                path: '/contact',
                component: Contact,
                name: 'contact',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.inquiry',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: '/contact/confirm',
                component: ContactConfirm,
                name: 'contactconfirm',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.inquiry',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: '/contact/complate',
                component: ContactComplate,
                name: 'contactcomplate',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.inquiry',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
        ],
    },
    //新規登録【アドバンス会員】ヘッダー・フッター
    {
        path: '/',
        component: LayoutForce,
        children: [
            //利用規約
            {
                path: 'registration-forceclub/terms',
                component: OutlineForce,
                name: 'termsForce',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.termsForce',
                    authorizedMembershipTypes: undefined,
                }
            },
            //FAQ
            {
                path: 'registration-forceclub/FAQ',
                component: commonFAQ,
            
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.commonFAQ',
                    authorizedMembershipTypes: undefined,
                }
            },
            //プライバシーポリシー
            {
                path: 'registration-forceclub/policy',
                component: commonPolicy,
           
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.commonPolicy',
                    authorizedMembershipTypes: undefined,
                }
            },
            //運営会社
            {
                path: 'registration-forceclub/company',
                component: commonCompany,
       
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.commonCompany',
                    authorizedMembershipTypes: undefined,
                }
            },
        ]
    },
    //新規登録【ベーシック会員】ヘッダー・フッター
    {
        path: '/',
        component: LayoutAube,
        children: [
            //利用規約
            {
                path: 'aube/terms',
                component: OutlineAube,
                name: 'termsAube',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.termsAube',
                    authorizedMembershipTypes: undefined,
                }
            },
            //FAQ
            {
                path: 'aube/FAQ',
                component: commonFAQ,
                name: 'commonFAQ',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.commonFAQ',
                    authorizedMembershipTypes: undefined,
                }
            },
            //プライバシーポリシー
            {
                path: 'aube/policy',
                component: commonPolicy,
                name: 'commonPolicy',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.commonPolicy',
                    authorizedMembershipTypes: undefined,
                }
            },
            //運営会社
            {
                path: 'aube/company',
                component: commonCompany,
                name: 'commonCompany',
                meta: {
                    requiresAuth: false,
                    titleKey: 'title.commonCompany',
                    authorizedMembershipTypes: undefined,
                }
            },
        ]
    },
    {
        path: '/membership',
        component: AppLayout,
        children: [
            //フォルシング開始手続き画面(規約)
            {
                path: 'policy',
                component: MembershipFeePolicy,
                name: 'MembershipFeePolicy',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.membershipFeePolicy',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            //フォルシング開始手続き画面(申込)
            {
                path: 'payment',
                component: MembershipFeePayments,
                name: 'MembershipFeePayments',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.membershipFeePayments',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            //フォルシング開始手続き画面(完了)
            {
                path: 'complete',
                component: MembershipFeeComplete,
                name: 'MembershipFeeComplete',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.membershipFeeComplete',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            //フォルシング開始(更新)手続き画面(規約)
            {
                path: 'policy-renewal',
                component: MembershipFeePolicyRenewal,
                name: 'MembershipFeePolicyRenewal',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.membershipFeePolicyRenewal',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            //フォルシング開始手続き画面
            {
                path: 'condition-renewal',
                component: MembershipFeeConditionRenewal,
                name: 'MembershipFeeConditionRenewal',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.membershipFeeConditionRenewal',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
             //フォルシング開始(更新)手続き画面(申込)
            {
                path: 'payment-renewal',
                component: MembershipFeePaymentsRenewal,
                name: 'MembershipFeePaymentsRenewal',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.membershipFeePaymentRenewal',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
            //フォルシング開始(更新)手続き画面(完了)
            {
                path: 'complete-renewal',
                component: MembershipFeeCompleteRenewal,
                name: 'MembershipFeeCompleteRenewal',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.membershipFeeCompleteRenewal',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                    ],
                }
            },
        ]
    },
    {
        path: '/dna',
        component: AppLayout,
        children: [
            {
                path: 'address',
                component: OrderAddress,
                name: 'OrderAddress',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.OrderAddress',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'amount',
                component: OrderAmount,
                name: 'OrderAmount',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.OrderAmount',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'confirm',
                component: OrderConfirm,
                name: 'OrderConfirm',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.OrderConfirm',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'payment',
                component: OrderPayment,
                name: 'OrderPayment',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.OrderPayment',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'success',
                component: OrderSuccess,
                name: 'OrderSuccess',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.OrderSuccess',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
            {
                path: 'failure',
                component: OrderFailure,
                name: 'OrderFailure',
                meta: {
                    requiresAuth: true,
                    titleKey: 'title.OrderFailure',
                    authorizedMembershipTypes: [
                        FORTHING_MEMBER_PARENT,
                        FORTHING_MEMBER_SUPPORT_PARENT,
                        GENERAL_FREE_MEMBER_PARENT,
                    ],
                }
            },
        ]
    },
    {
        path: '/paypal',
        component: AppLayout,
        children: [
            {
                path: 'subscribe',
                redirect: { name: 'home' }
            },
            {
                path: 'success',
                redirect: { name: 'home' }
            },
            {
                path: 'failure',
                redirect: { name: 'home' }
            },
            {
                path: 'payment',
                redirect: { name: 'home' }
            },
        ]
    },
    {
        path: '*',
        component: AppLayout,
        children: [
            {
                path: '*',
                component: PageNotFoundModule,
                name: 'pageNotFound',
                meta: {
                    requiresAuth: false,
                    authorizedMembershipTypes: undefined,
                }
            },
        ]
    }
]
